import { NgFor, NgForOf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';

@Component({
    imports: [MatDialogModule, MatTableModule, NgFor, MatButtonModule],
    standalone: true,
    selector: 'app-preview-excel-modal',
    templateUrl: './preview-excel.component.html',
})
export class PreviewExcelModalComponent {

    requiredFields = ['Código', 'Código Dirección', 'Código Ruta'];
    displayedColumns: string[] = [];
    validatedData: any[] = [];
    totalErrors = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { excelData: any[]; displayedColumns: string[] },
        private dialogRef: MatDialogRef<PreviewExcelModalComponent>) {
        this.validateData();
    }
    validateData() {
        this.displayedColumns = this.data.displayedColumns;
        this.validatedData = this.data.excelData.map(row => {
            const errors = this.requiredFields
                .filter(field => row[field] === null || row[field] === undefined || row[field] === '')
                .reduce((acc, field) => ({ ...acc, [field]: 'Campo requerido' }), {});

            return {
                ...row,
                _errors: errors,
                _isValid: Object.keys(errors).length === 0
            };
        });

        this.totalErrors = this.validatedData.filter(row => !row._isValid).length;
    }

    confirmImport() {
    this.dialogRef.close({
      data: this.validatedData,
      totalErrors: this.totalErrors
    });
  }
}